import baasService from '../services/baas.service';

const handlers = {
    baas: {
        session: {
            set: 'baas_session_set'
        }
    }
}

const initVuexState = function (state) {
    state.baas = {
        session: null
    };
}

const initGetters = function (getters) {
    getters.baas = (state => state.baas);
}

const initActions = function (actions) {
    actions[handlers.baas.session.set] = ({ commit }, session) => commit(handlers.baas.session.set, session);
}

const initMutations = function (mutations) {
    mutations[handlers.baas.session.set] = (state, session) => state.baas.session = session;
}

const initAppState = function (appState, store) {
    appState.baas = {
        session: {
            get: () => store.getters.baas.session,
            open: async (gameId) => {
                let session = await baasService.openSession(gameId);
                store.dispatch(handlers.baas.session.set, session);
            },
            openDemo: async (gameId) => {
                let session = await baasService.openDemoSession(gameId);
                store.dispatch(handlers.baas.session.set, session);
            },
            close: async () => {
                if (store.getters.baas.session) {
                    await baasService.closeSession();
                }
                store.dispatch(handlers.baas.session.set, null);
            }
        }
    }
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
}



// WEBPACK FOOTER //
// ./_common/data/baas.js